import { Button } from "@common/index";
import { ComponentColor } from "@common/types";
import { ROUTES } from "@routing/routes";

interface NotFoundContentProps {
    /** Destination for the primary CTA (e.g. home or admin dashboard). */
    primaryTo: string;
    /** Label for the primary CTA (e.g. "Go home" or "Go to dashboard"). */
    primaryLabel: string;
}

export const NotFoundContent = ({
    primaryTo,
    primaryLabel,
}: NotFoundContentProps) => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-16 text-center text-primary">
            <p className="text-5xl font-bold text-primary">404</p>
            <h1 className="mt-4 uppercase text-4xl font-bold">
                Page not found
            </h1>
            <p className="text-base mt-6">
                Sorry, we can't find the page you're looking for. It may have
                been moved, or the link may be out of date.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                <Button to={primaryTo} color={ComponentColor.Primary}>
                    {primaryLabel}
                </Button>
                {/* Outline button on a light surface: add a readable text token
                    because the theme sets --color-base-content to #fff. */}
                <Button to={ROUTES.SUPPORT} outline className="text-neutral">
                    Contact support
                </Button>
            </div>
        </div>
    );
};
